/** Guided Boxify targets. Must stay aligned with worker TARGET_DEVICE_PRESETS. */
export const BOXIFY_TARGET_PRESETS = {
  phone: {
    target_device: 'phone',
    weights: 'boxify_s_relu',
    image_size: 320,
    epochs: 100,
    assigner: 'tal',
    optimizer: 'AdamW',
    bbox_loss: 'giou',
    tflite_export: 'Yes',
  },
  edge: {
    target_device: 'edge',
    weights: 'boxify_tiny_relu',
    image_size: 256,
    epochs: 100,
    assigner: 'tal',
    optimizer: 'AdamW',
    bbox_loss: 'giou',
    tflite_export: 'Yes',
  },
  guidance: {
    target_device: 'guidance',
    weights: 'boxify_s_p2',
    image_size: 640,
    epochs: 150,
    assigner: 'tal',
    optimizer: 'AdamW',
    bbox_loss: 'giou',
    tflite_export: 'Yes',
  },
  gpu: {
    target_device: 'gpu',
    weights: 'boxify_s',
    image_size: 640,
    epochs: 300,
    assigner: 'tal',
    optimizer: 'AdamW',
    bbox_loss: 'giou',
    tflite_export: 'Yes',
  },
};

export const BOXIFY_TARGET_IDS = Object.keys(BOXIFY_TARGET_PRESETS);
